module.exports = __webpack_public_path__ + "img/activity_31.774eea21.jpg";